import axios from "axios";
import { useEffect, useState } from "react";
import Confetti from "react-confetti";
import Rating from "react-rating-stars-component";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../AuthContext";
import careerRecommendations from "../../homeComponents/careerRecommendations";
import SelfPacedLearning from "../../homeComponents/SelfPacedLearning";
import UserFeedback from "../../homeComponents/UserFeedback";
import profile from "../../images/profile_icon.png";
import ProfileHeader from "../ProfileHeader";
import "./UserProfile.css";

// const BASE_URL = "http://localhost:8000";
const BASE_URL = "https://idealpursuits.co.in/api";

function UserProfile({ userData }) {
    const [expertMeetings, setExpertMeetings] = useState(null);
    const [mentorMeetings, setMentorMeetings] = useState(null);
    const [seminarBookings, setSeminarBookings] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showConfetti, setShowConfetti] = useState(false);
    const { liveUserData, login } = useAuth();
    const navigate = useNavigate();
    const [showReschedulePopup, setShowReschedulePopup] = useState(false);
    const [selectedMeeting, setSelectedMeeting] = useState(null);
    const [availableDates, setAvailableDates] = useState([]);
    const [availableTimes, setAvailableTimes] = useState([]);
    const [selectedDate, setSelectedDate] = useState("");
    const [selectedTime, setSelectedTime] = useState("");
    const [tutorDetails, setTutorDetails] = useState(null);
    const [isMeetingAttended, setIsMeetingAttended] = useState(false);
    const [isExpertMeetingAttended, setIsExpertMeetingAttended] = useState(false);
    const [meetingUpdateSuccess, setMeetingUpdateSuccess] = useState(false);
    const [dateTimeMap, setDateTimeMap] = useState({});
    const [ratingSelectedMeeting, setRatingSelectedMeeting] = useState(null);
    const [showRatingPopup, setShowRatingPopup] = useState(false);
    const [selectedRating, setSelectedRating] = useState(0);

    const loadMeetingStatus = async () => {
        try {
            const meetingResponse = await axios.post(`${BASE_URL}/getMeetingAttended.php`, {
                userId: userData.userId
            });
            setIsMeetingAttended(meetingResponse.data[0].isMeetingAttended == 1);
            setIsExpertMeetingAttended(meetingResponse.data[0].isExpertMeetingAttended == 1);
            console.log(isMeetingAttended);
            console.log(isExpertMeetingAttended);
        } catch (error) {
            console.error("Error fetching meeting status:", error);
        }
    };

    useEffect(() => {
        loadMeetingStatus();
    }, [userData.userId]);

    const canReschedule = (meeting) => {
        const meetingDate = new Date(`${meeting.meetingDate} ${meeting.meetingTime}`);
        const now = new Date();
        const hoursDifference = (meetingDate - now) / (1000 * 60 * 60);
        return hoursDifference >= 12 && !meeting.isRescheduled;
    };

    const getRescheduleStatus = (meeting) => {
        if (meeting.isRescheduled) return 'Rescheduled';
        if (!meeting.isRescheduled) return 'Fixed';
        return canReschedule(meeting) ? 'Reschedule' : 'Fixed';
    };

    const handleRescheduleClick = async (meeting, title) => {
        try {
            let response, datesResponse;

            // Fetch tutor details based on title
            if (title === "Career Coaches") {
                response = await axios.get(`${BASE_URL}/mentor/getMentorDetails.php?mentorId=${meeting.tutorId}`);
                datesResponse = await axios.get(`${BASE_URL}/mentor/getMentorDatesForUser.php?mentorId=${meeting.tutorId}`);
            } else {
                response = await axios.get(`${BASE_URL}/expert/getExpertDetails.php?expertId=${meeting.tutorId}`);
                datesResponse = await axios.get(`${BASE_URL}/expert/getExpertDatesForUser.php?expertId=${meeting.tutorId}`);
            }

            const tutor = response.data;
            const datesData = datesResponse.data;
            const currentTime = new Date().getTime();

            const dateTimeMap = {}; // Object to store times for each date
            const availableDates = [];

            // Process dates and times
            datesData.forEach((entry) => {
                const { id, date, times: time } = entry;
                const entryDateTime = new Date(`${date}T${time}`).getTime();

                // Filter for upcoming dates and times at least 12 hours ahead
                if (entryDateTime > currentTime + 12 * 60 * 60 * 1000) {
                    if (!dateTimeMap[date]) {
                        dateTimeMap[date] = [];
                        availableDates.push(date); // Add date only once
                    }
                    dateTimeMap[date].push({ id, time }); // Retain id along with time
                }
            });

            // Sort dates in ascending order
            availableDates.sort((a, b) => new Date(a) - new Date(b));

            // Update state
            setAvailableDates(availableDates);
            setDateTimeMap(dateTimeMap); // Store date-time mapping with IDs

            // Set default selected date and time
            if (availableDates.length > 0) {
                setSelectedDate(availableDates[0]);
                const sortedTimes = dateTimeMap[availableDates[0]].sort((a, b) => a.time.localeCompare(b.time));
                setAvailableTimes(sortedTimes);
                setSelectedTime(sortedTimes[0]); // Default selected time includes id
            }

            setTutorDetails(tutor);
            setSelectedMeeting(meeting);
            setShowReschedulePopup(true);

        } catch (error) {
            console.error("Error fetching tutor details or dates:", error);
        }
    };

    const handleRescheduleSubmit = async () => {
        try {
            const response = await axios.post(`${BASE_URL}/rescheduleMeeting.php`, {
                meetingId: selectedMeeting.meetingId,
                newDate: selectedDate,
                oldBookedDateId: selectedMeeting.bookedDateId,
                newBookedDateId: selectedTime.id,
                newTime: convertTo12HrFormat(selectedTime.time)
            });

            if (selectedMeeting.tutorType === 'mentor') {
                await axios.post(`${BASE_URL}/setMentorDateBooked.php`, {
                    id: selectedTime.id
                });

                await axios.post(`${BASE_URL}/setMentorDateNotBooked.php`, {
                    id: selectedMeeting.bookedDateId
                });
            } else {
                await axios.post(`${BASE_URL}/setExpertDateBooked.php`, {
                    id: selectedTime.id
                });

                await axios.post(`${BASE_URL}/setExpertDateNotBooked.php`, {
                    id: selectedMeeting.bookedDateId
                });
            }

            if (response.data.status === "success") {
                setMeetingUpdateSuccess(true);
                setShowReschedulePopup(false);
                fetchMeetings();
            }
        } catch (error) {
            console.error("Error rescheduling meeting:", error);
        }
    };

    const convertTo12HrFormat = (time) => {
        const [hour, minute] = time.split(":");
        let newHour = hour % 12;
        newHour = newHour ? newHour : 12;
        const ampm = hour >= 12 ? "PM" : "AM";
        return `${newHour}:${minute} ${ampm}`;
    };

    const openRatingPopup = (meeting) => {
        setRatingSelectedMeeting(meeting);
        setSelectedRating(meeting.rating || 0);
        setShowRatingPopup(true);
    };

    const handleSubmitRating = async () => {
        if (!ratingSelectedMeeting) return;
        try {
            await axios.post(`${BASE_URL}/setRating.php`, {
                meetingId: ratingSelectedMeeting.meetingId,
                rating: selectedRating
            });
            setShowRatingPopup(false);
            fetchMeetings();
        } catch (error) {
            console.error("Error submitting rating:", error);
        }
    };

    const renderMeetingsTable = (meetings, title) => (
        <div className="user-profile-card">
            <h2>{title}</h2>
            {meetings && meetings.length > 0 ? (
                <table>
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Time</th>
                            <th>Tutor</th>
                            <th>URL</th>
                            <th>Status</th>
                            <th>Rating</th>
                        </tr>
                    </thead>
                    <tbody>
                        {meetings.map((meeting) => (
                            <tr key={meeting.meetingId}>
                                <td>{formatToDate(meeting.meetingDate)}</td>
                                <td>{meeting.meetingTime}</td>
                                <td>{meeting.tutorName}</td>
                                <td><a href={meeting.meetingLink}>Link</a></td>
                                <td>
                                    {canReschedule(meeting) ? (
                                        <button
                                            onClick={() => handleRescheduleClick(meeting, title)}
                                            className="reschedule-button"
                                        >
                                            Reschedule
                                        </button>
                                    ) : (
                                        <span>{getRescheduleStatus(meeting)}</span>
                                    )}
                                </td>
                                <td>
                                    {meeting.rating > 0 ? (
                                        <span>⭐{parseFloat(meeting.rating).toFixed(1)}</span>
                                    ) : (
                                        <button onClick={() => openRatingPopup(meeting)} className="rate-button">
                                            ⭐
                                        </button>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            ) : (
                <p>No meetings scheduled. <a href={title === "Career Coaches" ? "/career-coaches" : "/professionals"}>Schedule one now!</a></p>
            )}
        </div>
    );

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    const calculateProgress = (liveUserData) => {
        let progress = 0;
        const totalSteps = 3;

        if (liveUserData?.courseTaken) progress += 1;
        if (liveUserData?.InternshipTaken) progress += 1;
        if (liveUserData?.spfFinished) progress += 1;

        return (progress / totalSteps) * 100;
    };

    const progress = calculateProgress(liveUserData);

    // Split the comma-separated string into an array
    const recommendedCategories = liveUserData?.recommendedCareer
        ? liveUserData?.recommendedCareer.split(",").map((category) => category.trim())
        : [];

    // Map recommended categories to descriptions and careers
    const mappedRecommendations = recommendedCategories.map((category) => ({
        category: category,
        description: careerRecommendations[category]?.description || "Explore this field for more opportunities.",
        careers: careerRecommendations[category]?.careers || [],
    }));

    const fetchMeetings = async () => {
        try {
            const response = await axios.post(`${BASE_URL}/getMeetingsForUser.php`, { userId: liveUserData?.userId });
            const data = response?.data;

            // Separate meetings by tutor type
            const mentorMeetings = data?.filter((meeting) => meeting.tutorType === 'mentor');
            const expertMeetings = data?.filter((meeting) => meeting.tutorType === 'expert');

            // Update states with filtered meetings
            setMentorMeetings(mentorMeetings);
            setExpertMeetings(expertMeetings);
        } catch (error) {
            console.error("Error fetching mentor details:", error);
        }
    };

    useEffect(() => {
        fetchMeetings();
    }, [liveUserData]);

    useEffect(() => {
        const fetchSeminars = async () => {
            try {
                const response = await axios.post(`${BASE_URL}/getSeminarsForUser.php`, { userId: liveUserData?.userId });
                setSeminarBookings(response.data);
            } catch (error) {
                console.error("Error fetching seminars:", error);
            }
        };

        fetchSeminars();
    }, []);

    // const searchCoursesInTabs = (recommendedCareer) => {
    //     if (!recommendedCareer) return;

    //     const careers = recommendedCareer.split(',').map(career => career.trim());

    //     console.log(careers);
    //     careers.forEach((career) => {
    //         console.log('for career 1');
    //         const searchUrl = `https://www.google.com/search?q=${encodeURIComponent(career + " Course")}`;
    //         window.open(searchUrl, '_blank');
    //     });
    // };    

    const handleYesCourse = async () => {
        try {
            await axios.post(`${BASE_URL}/saveProgress.php`, {
                categories: liveUserData?.recommendedCareer,
                recommendedTime: liveUserData?.recommendedCareerTime,
                userId: liveUserData?.userId,
                courseTaken: 1
            });

            // Update liveUserData? and login
            const updatedUserData = { ...liveUserData, courseTaken: true };
            login(updatedUserData);

        } catch (error) {
            console.error('Error saving course progress:', error);
        }
    };

    const handleYesInternship = async () => {
        try {
            // Google search logic: open in a new window
            // window.open(`https://www.google.com/search?q=Internship+on+${liveUserData?.recommendedCareer}`, '_blank');

            // Update InternshipTaken in database
            await axios.post(`${BASE_URL}/saveProgress.php`, {
                categories: liveUserData?.recommendedCareer,
                recommendedTime: liveUserData?.recommendedCareerTime,
                userId: liveUserData?.userId,
                courseTaken: 1,
                InternshipTakenTime: Date.now(),
                InternshipTaken: 1,
            });

            // Update liveUserData? and login
            const updatedUserData = { ...liveUserData, InternshipTaken: true, InternshipTakenTime: Date.now() };
            login(updatedUserData);

        } catch (error) {
            console.error('Error saving internship progress:', error);
        }
    };

    const handleExpertsContinue = async () => {
        try {
            // Save SPF Finished status
            await axios.post(`${BASE_URL}/saveProgress.php`, {
                categories: liveUserData?.recommendedCareer,
                recommendedTime: liveUserData?.recommendedCareerTime,
                userId: liveUserData?.userId,
                courseTaken: 1,
                courseTakenTime: liveUserData?.courseTakenTime ? liveUserData?.courseTakenTime : 0,
                InternshipTaken: 1,
                InternshipTakenTime: liveUserData?.InternshipTakenTime ? liveUserData?.InternshipTakenTime : 0,
                spfFinished: 1,
            });

            // Update liveUserData? and login
            const updatedUserData = { ...liveUserData, spfFinished: true };
            login(updatedUserData);
            console.log(liveUserData);

            setShowConfetti(true);
            setTimeout(() => setShowConfetti(false), 3000);

            // Navigate to meet experts page
            // window.location.href = '/meet-experts';
        } catch (error) {
            console.error('Error saving SPF finished:', error);
        }
    };

    const formatToDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const formatTo12Hr = (time) => {
        const [hour, minute] = time.split(":");
        const formattedHour = hour % 12 || 12;
        const period = hour >= 12 ? "PM" : "AM";
        return `${formattedHour}:${minute} ${period}`;
    };

    return (
        <div>
            <ProfileHeader />
            <div className="user-profile-container">
                <div className="user-profile-wrapper">
                    {/* Left Section */}
                    <div className="user-profile-left">
                        <div className="user-profile-data-card">
                            <img
                                src={profile}
                                alt={liveUserData?.name}
                                className="profile-image"
                            />
                            <h2>Welcome, {liveUserData?.name}</h2>
                            <p>Member since: {new Date(liveUserData?.createdAt).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })}</p>
                        </div>
                    </div>

                    {/* Right Section */}
                    <div className="user-profile-right">
                        {/* Top Right Section */}
                        <div className="user-profile-card user-profile-progress">
                            {/* {progress > 10 ? (
                                <div className="progress-container">
                                    <h2>Progress:</h2>
                                    <progress value={progress} max={100} className="progress-bar"></progress>
                                </div>
                            ) : progress === 100 ? (
                                <h2>Congratulations on finding your Dream Career🎉!</h2>
                            ) : (
                                <div className="progress-container">
                                    <p>
                                        You haven't started yet.{" "}
                                        <a href="/">Start your journey now!</a>
                                    </p>
                                </div>
                            )} */}
                            {recommendedCategories.length > 0 && (
                                <div className="career-progress">
                                    <h2>Recommended Career Paths:</h2>
                                    {mappedRecommendations.map(({ category, description, careers }) => (
                                        <div key={category} className="career-progress-item">
                                            <h4 style={{ color: "green" }}>
                                                {category.charAt(0).toUpperCase() + category.slice(1)}
                                            </h4>
                                            <p>{description}</p>
                                            {careers.length > 0 && (
                                                <ul className="career-list">
                                                    {careers.map((career) => (
                                                        <li key={career}>
                                                            <a
                                                                href={`https://www.google.com/search?q=${career}`}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                {career}
                                                            </a>
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            )}

                            {showConfetti && <Confetti />}
                            <h2>Self-Exploration Progress</h2>
                            <div className="spf-career-exploration-container">
                                <div className="career-exploration-wrapper">
                                    <h2 className="career-exploration-title">Your Self-Exploration Progress</h2>

                                    {liveUserData?.recommendedCareer && (
                                        <div className="career-stage-section">
                                            <h3 className="recommended-career-title">
                                                Recommended Career: {liveUserData?.recommendedCareer}
                                            </h3>

                                            {/* Course Recommendation Section */}
                                            {!liveUserData?.courseTaken && (
                                                <div className="career-recommendation-card course-recommendation">
                                                    <div className="recommendation-icon">📚</div>
                                                    <div className="recommendation-content">
                                                        <h3>Take the Next Step in Your Career Journey</h3>
                                                        <div className="career-roadmap">
                                                            <h4>📍 Your Career Roadmap</h4>
                                                            <div className="roadmap-steps">
                                                                <span className="step completed">Career Test ✅</span>
                                                                <span className="arrow">→</span>
                                                                <span className="step">Courses</span>
                                                                <span className="arrow">→</span>
                                                                <span className="step">Internship</span>
                                                                <span className="arrow">→</span>
                                                                <span className="meet-step">Coach</span>
                                                                <span className="arrow">→</span>
                                                                <span className="meet-step">Expert</span>
                                                            </div>
                                                        </div>
                                                        <p>
                                                            Based on your interest in <strong>{liveUserData?.recommendedCareer}</strong>, here are some suggestions to help
                                                            you succeed in this field. The first step could be gaining foundational knowledge through courses.
                                                        </p>
                                                        <ul>
                                                            <li>📘 <strong>Courses:</strong> Enroll in a course on {liveUserData?.recommendedCareer} to build a strong foundation.</li>
                                                            <li>💡 <strong>Internships:</strong> Apply your knowledge with hands-on experience in the industry.</li>
                                                            <li>🎓 <strong>Mentorship:</strong> Connect with experts to get guidance on advanced topics and career advice.</li>
                                                        </ul>
                                                        <br />
                                                        <div className="career-progress-extra-resources">
                                                            <h4 style={{ fontSize: "15px", fontStyle: "italic" }}>How to Find the Right Courses:</h4>
                                                            <ul>
                                                                {liveUserData?.recommendedCareer.split(',').map((career, index) => (
                                                                    <li key={index}>
                                                                        <a
                                                                            href={`https://www.google.com/search?q=${encodeURIComponent(career.trim())}+Courses`}
                                                                            target="_blank"
                                                                            rel="noopener noreferrer"
                                                                        >
                                                                            Search for Courses in {career.trim()} &rarr;
                                                                        </a>
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        </div>
                                                        <br />
                                                        <div className="recommendation-actions">
                                                            {/* <button
                                                                onClick={() => {searchCoursesInTabs(liveUserData?.recommendedCareer)}}
                                                                className="btn btn-primary"
                                                            >
                                                                Find Courses
                                                            </button> */}
                                                            <button onClick={handleYesCourse} className="btn btn-primary">
                                                                I've Completed a Course
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            {/* Internship Recommendation Section */}
                                            {liveUserData?.courseTaken && !liveUserData?.InternshipTaken && (
                                                <div className="career-recommendation-card internship-recommendation">
                                                    <div className="recommendation-icon">💼</div>
                                                    <div className="recommendation-content">
                                                        <h3>Take Your Career to the Next Level with an Internship</h3>
                                                        <div className="career-roadmap">
                                                            <h4>📍 Your Career Roadmap</h4>
                                                            <div className="roadmap-steps">
                                                                <span className="step completed">Career Test ✅</span>
                                                                <span className="arrow">→</span>
                                                                <span className="step completed">Courses ✅</span>
                                                                <span className="arrow">→</span>
                                                                <span className="step">Internship</span>
                                                                <span className="arrow">→</span>
                                                                <span className="meet-step">Coach</span>
                                                                <span className="arrow">→</span>
                                                                <span className="meet-step">Expert</span>
                                                            </div>
                                                        </div>
                                                        <p>
                                                            An internship in <strong>{liveUserData?.recommendedCareer}</strong> can be an excellent way to gain hands-on experience,
                                                            build industry connections, and enhance your resume. It’s a crucial step in becoming a professional in this field.
                                                        </p>
                                                        <ul>
                                                            <li>👨‍💼 <strong>Industry Exposure:</strong> Learn the real-world applications of your skills.</li>
                                                            <li>💼 <strong>Build Your Network:</strong> Collaborate with professionals and grow your industry contacts.</li>
                                                            <li>📈 <strong>Enhance Your Profile:</strong> Make your resume stand out with practical experience.</li>
                                                        </ul>
                                                        <div className="career-progress-extra-resources">
                                                            <h4 style={{ fontSize: "15px", fontStyle: "italic" }}>How to Find the Right Internship:</h4>
                                                            <ul>
                                                                {liveUserData?.recommendedCareer.split(',').map((career, index) => (
                                                                    <li key={index}>
                                                                        <a
                                                                            href={`https://www.google.com/search?q=${career.trim()}+Internship`}
                                                                            target="_blank"
                                                                            rel="noopener noreferrer"
                                                                        >
                                                                            Search for Internships in {career.trim()} &rarr;
                                                                        </a>
                                                                    </li>
                                                                ))}
                                                                <li>
                                                                    <a href="https://internshala.com/" target="_blank" rel="noopener noreferrer">
                                                                        Explore Opportunities on Internshala &rarr;
                                                                    </a>
                                                                </li>
                                                                <li>
                                                                    <a href="https://www.linkedin.com/jobs/" target="_blank" rel="noopener noreferrer">
                                                                        Browse Internships on LinkedIn Jobs &rarr;
                                                                    </a>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                        <br />
                                                        <div className="recommendation-actions">
                                                            {/* <a
                                                                href={`https://www.google.com/search?q=${encodeURIComponent(liveUserData?.recommendedCareer)}+Internships`}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className="btn btn-primary"
                                                            >
                                                                Find Internships
                                                                </a> */}
                                                            <button
                                                                onClick={handleYesInternship}
                                                                className="btn btn-primary"
                                                            >
                                                                I've Completed an Internship
                                                            </button>
                                                            <button
                                                                onClick={handleYesInternship}
                                                                className="btn btn-secondary"
                                                            >
                                                                No, I need Help
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            {/* Expert Connection Section */}
                                            {liveUserData?.courseTaken && liveUserData?.InternshipTaken && !isMeetingAttended && (
                                                <div className="career-recommendation-card career-coach-recommendation">
                                                    <div className="recommendation-icon">📢</div>
                                                    <div className="recommendation-content">
                                                        <h4>Connect with a Career Coach</h4>
                                                        <p>
                                                            It’s great that you’re exploring <strong>{liveUserData?.recommendedCareer}</strong>! But have you had guidance on aligning your skills with your career aspirations?
                                                        </p>
                                                        <ul>
                                                            <li>📚 <strong>Courses:</strong> Have they given you clarity about your future goals?</li>
                                                            <li>💼 <strong>Internships:</strong> Have you been able to apply what you learned if you had taken an Internship?</li>
                                                        </ul>
                                                        <div className="career-roadmap">
                                                            <h4>📍 Your Career Roadmap</h4>
                                                            <div className="roadmap-steps">
                                                                <span className="step completed">Career Test ✅</span>
                                                                <span className="arrow">→</span>
                                                                <span className="step completed">Courses ✅</span>
                                                                <span className="arrow">→</span>
                                                                <span className="step completed">Internship ✅</span>
                                                                <span className="arrow">→</span>
                                                                <span className="step">Coach</span>
                                                                <span className="arrow">→</span>
                                                                <span className="step">Expert</span>
                                                            </div>
                                                        </div>
                                                        <p>
                                                            If you're unsure about the next steps, speaking with a career coach could provide valuable direction and strategies to refine your career path.
                                                        </p>
                                                        <div className="recommendation-actions">
                                                            <button onClick={() => navigate("/career-coaches")} className="btn btn-secondary">
                                                                Consult Career Coaches
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            {liveUserData?.courseTaken && liveUserData?.InternshipTaken && isMeetingAttended && !isExpertMeetingAttended && (
                                                <div className="career-recommendation-card expert-recommendation">
                                                    <div className="recommendation-icon">🤝</div>
                                                    <div className="recommendation-content">
                                                        <h4>Connect with Industry Experts</h4>
                                                        <p>
                                                            You’ve made great progress toward <strong>{liveUserData?.recommendedCareer}</strong>! Now, connecting with professionals in the field can help you gain insights and better understand industry demands.
                                                        </p>
                                                        <ul>
                                                            <li>🔬 <strong>Research:</strong> Are you gaining practical knowledge in your field?</li>
                                                            <li>💡 <strong>Insights:</strong> Do you understand the career landscape and the best opportunities available?</li>
                                                        </ul>
                                                        <div className="career-roadmap">
                                                            <h4>📍 Your Career Roadmap</h4>
                                                            <div className="roadmap-steps">
                                                                <span className="step completed">Career Test ✅</span>
                                                                <span className="arrow">→</span>
                                                                <span className="step completed">Courses ✅</span>
                                                                <span className="arrow">→</span>
                                                                <span className="step completed">Internship ✅</span>
                                                                <span className="arrow">→</span>
                                                                <span className="step completed">Coach ✅</span>
                                                                <span className="arrow">→</span>
                                                                <span className="step">Expert</span>
                                                            </div>
                                                        </div>
                                                        <p>
                                                            Getting industry exposure is crucial. Experts can guide you with firsthand experiences and trends shaping your profession.
                                                        </p>
                                                        <div className="recommendation-actions">
                                                            <button onClick={() => navigate("/professionals")} className="btn btn-primary">
                                                                Talk to Industry Experts
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            {/* Final Stage Confirmation */}
                                            {liveUserData?.courseTaken && liveUserData?.InternshipTaken && (
                                                <div className="final-stage-confirmation">
                                                    {isMeetingAttended && isExpertMeetingAttended ? (
                                                        <div className="success-message">
                                                            {liveUserData?.spfFinished ? (
                                                                <div>
                                                                    <h3>🎉 <b><i>Congratulations!</i></b>🚀</h3>
                                                                    <p>
                                                                        <strong>You've successfully navigated your career exploration journey.
                                                                            Your dedication and strategic approach have brought you to your dream career.</strong>
                                                                    </p>
                                                                    <UserFeedback showFeedbackTitle={false} />
                                                                </div>
                                                            ) : (
                                                                <div>
                                                                    <h3>🎉 Bravo! 🚀</h3>
                                                                    <p>
                                                                        You've sought guidance from a Career Coach and an Industry Expert. How do you feel about your journey? Do you feel like:
                                                                    </p>
                                                                    <div className="final-action-buttons">
                                                                        <button
                                                                            onClick={handleExpertsContinue}
                                                                            className="btn btn-success"
                                                                        >
                                                                            I've Found My Dream Career
                                                                        </button>
                                                                        <button
                                                                            onClick={openModal}
                                                                            className="btn btn-outline"
                                                                        >
                                                                            Explore Further
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    ) : null}
                                                </div>
                                            )}
                                        </div>
                                    )}

                                    {/* Initial Start Option */}
                                    {!liveUserData?.recommendedCareer && !liveUserData?.courseTaken && !liveUserData?.InternshipTaken && !liveUserData?.spfFinished && (
                                        <div className="start-exploration-section">
                                            <h3>Begin Your Career Discovery Journey</h3>
                                            <p>Take the first step towards understanding your true professional potential.</p>
                                            <button
                                                onClick={openModal}
                                                className="btn btn-primary start-exploration-btn"
                                            >
                                                Start Self-Exploration
                                            </button>
                                        </div>
                                    )}
                                </div>

                                <SelfPacedLearning isOpen={isModalOpen} closeModel={closeModal} reloadFunction={loadMeetingStatus} />
                            </div>

                            <div className="user-profile-card">
                                <h2>Seminars</h2>
                                {seminarBookings && seminarBookings.length > 0 ? (
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>Title</th>
                                                <th>Date</th>
                                                <th>Time</th>
                                                <th>Booked on</th>
                                                <th>URL</th>
                                                <th>Passcode</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {seminarBookings.map((seminar) => (
                                                <tr key={seminar.seminarId}>
                                                    <td>{seminar.title}</td>
                                                    <td>{seminar.seminarDate}</td>
                                                    <td>{seminar.seminarTime}</td>
                                                    <td>{seminar.createdAt}</td>
                                                    <td><a href={seminar.meetingUrl}>Link</a></td>
                                                    <td>{seminar.meetingPasscode}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                ) : (
                                    <p>No seminars booked yet.</p>
                                )}
                            </div>
                        </div>

                        {/* Bottom Right Section */}
                        <div className="user-profile-meetings">
                            {renderMeetingsTable(mentorMeetings, "Career Coaches")}
                            {renderMeetingsTable(expertMeetings, "Professionals")}

                            {showRatingPopup && (
                                <div className="rating-popup-modal">
                                    <div className="rating-popup-content">
                                        <h3>Rate Your Meeting with {ratingSelectedMeeting.tutorName}</h3>
                                        <Rating
                                            count={5}
                                            value={selectedRating}
                                            onChange={setSelectedRating}
                                            size={30}
                                            half={true}
                                            activeColor="#ffd700"
                                        />
                                        <div className="rating-popup-actions">
                                            <button onClick={() => setShowRatingPopup(false)}>Cancel</button>
                                            <button onClick={handleSubmitRating}>Submit</button>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {showReschedulePopup && tutorDetails && (
                                <div className="booking-popup-modal">
                                    <div className="reschedule-popup-content">
                                        <h2>Reschedule Meeting</h2>
                                        <div className="mentor-info-container">
                                            {tutorDetails.profileImageName && (
                                                <img
                                                    src={`${BASE_URL}/images/profile/${tutorDetails.profileImageName}`}
                                                    alt={tutorDetails.name}
                                                    className="profile-image"
                                                />
                                            )}
                                            <h2>{tutorDetails.name}</h2>
                                            <p>{tutorDetails.profession}</p>
                                            <p>{tutorDetails.category}</p>
                                        </div>

                                        <div className="booking-details-container">
                                            <p><strong>Select new date:</strong></p>
                                            <div className="booking-dates">
                                                {availableDates.map((date, index) => (
                                                    <div
                                                        key={index}
                                                        className={`booking-date-item ${selectedDate === date ? "selected" : ""}`}
                                                        onClick={() => {
                                                            setSelectedDate(date);
                                                            setAvailableTimes(dateTimeMap[date].sort()); // Update times when date is selected
                                                            setSelectedTime(dateTimeMap[date][0]);       // Set the first time as default
                                                        }}
                                                    >
                                                        {formatToDate(date)}
                                                    </div>
                                                ))}
                                            </div>

                                            <p><strong>Select new time:</strong></p>
                                            <div className="booking-times">
                                                {availableTimes.map(({ id, time }, index) => (
                                                    <div
                                                        key={id}
                                                        className={`booking-time-item ${selectedTime?.time === time ? "selected" : ""}`}
                                                        onClick={() => setSelectedTime({ id, time })}
                                                    >
                                                        {formatTo12Hr(time)}
                                                    </div>
                                                ))}
                                            </div>

                                            <div className="popup-buttons">
                                                <button
                                                    className="close-popup-button"
                                                    onClick={() => setShowReschedulePopup(false)}
                                                >
                                                    Cancel
                                                </button>
                                                <button
                                                    className="continue-to-payment-button"
                                                    onClick={handleRescheduleSubmit}
                                                >
                                                    Confirm Reschedule
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {meetingUpdateSuccess && (
                                <div className="booking-popup-modal">
                                    <div className="popup-content">
                                        <h2>Meeting Rescheduling Successful</h2>
                                        <p>
                                            Your meeting is rescheduled successfully.
                                        </p>
                                        <button className="close-popup-button" onClick={() => setMeetingUpdateSuccess(false)}>
                                            Close
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default UserProfile;
